const CHAVE_TOKEN = "token-help";

function real(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

// "2026-08-09" -> "09/08/2026"
function dataBR(iso) {
  if (!iso) return "";
  const [ano, mes, dia] = String(iso).slice(0, 10).split("-");
  return `${dia}/${mes}/${ano}`;
}

function hojeISO() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

// Monta o link de cobrança/contato no WhatsApp
function linkWhatsApp(telefone, mensagem) {
  const numeros = String(telefone || "").replace(/\D/g, "");
  const ddi = numeros.startsWith("55") ? numeros : `55${numeros}`;
  return `https://wa.me/${ddi}?text=${encodeURIComponent(mensagem)}`;
}

export { CHAVE_TOKEN, real, dataBR, hojeISO, linkWhatsApp };
